import { Form, Input, Row, Col } from "antd";

const ChangePasswordForm = ({ form }) => {
  return (
    <>
      <Row gutter={24}>
        <Col span={24}>
          <Form.Item
            label="Yeni Şifre"
            name="password"
            rules={[
              {
                required: true,
                message: "Lütfen yeni şifrenizi giriniz!",
              },
              () => ({
                validator(_, value) {
                  if (!value) {
                    return Promise.reject();
                  }
                  if (value.length < 8) {
                    return Promise.reject(
                      "Yeni şifreniz en az 8 haneli olmalı!"
                    );
                  }
                  if (!/[a-z]/.test(value)) {
                    return Promise.reject(
                      "Yeni şifreniz en az bir küçük harf içermeli!"
                    );
                  }
                  if (!/[A-Z]/.test(value)) {
                    return Promise.reject(
                      "Yeni şifreniz en az bir büyük harf içermeli!"
                    );
                  }
                  if (!/[0-9]/.test(value)) {
                    return Promise.reject(
                      "Yeni şifreniz en az bir rakam içermeli!"
                    );
                  }
                  if (!/[!@#$%^&*(),.":{}|<>_\-+=\[\]\\\/]/.test(value)) {
                    return Promise.reject(
                      "Yeni şifreniz en az bir özel karakter içermeli!"
                    );
                  }
                  if (/\$/.test(value)) {
                    return Promise.reject("Yeni şifreniz $ işareti içeremez!");
                  }
                  if (/\s/.test(value)) {
                    return Promise.reject("Yeni şifreniz boşluk içeremez!");
                  }

                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input.Password size="large" style={{ borderRadius: "10px" }} />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item
            label="Yeni Şifre tekrarı"
            name="rePassword"
            rules={[
              {
                required: true,
                message: "Lütfen yeni şifre tekrarını giriniz!",
              },
              () => ({
                validator(_, value) {
                  if (!value) {
                    return Promise.reject();
                  }

                  if (value !== form.getFieldValue("password")) {
                    return Promise.reject(
                      "Yeni şifreniz ve yeni şifre tekrarınız eşleşmeli!"
                    );
                  }

                  return Promise.resolve();
                },
              }),
            ]}
          >
            <Input.Password size="large" style={{ borderRadius: "10px" }} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default ChangePasswordForm;
